import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Workbook as wb} from "exceljs";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {ModificacionMarcionesService} from "../../services/modificacion-marcaciones.service";
import {forkJoin} from "rxjs";

@Component({
  selector: 'app-modificacion-marcaciones',
  templateUrl: './modificacion-marcaciones.component.html',
  styleUrls: ['./modificacion-marcaciones.component.css']
})
export class ModificacionMarcacionesComponent implements OnInit {

  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  formularioMarcacion: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;
  cmbDepartment: any[] = [];
  cmbEmployees: any[] = [];

  workbook: wb;
  data: any = [];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;
  recursosHumanos = false;
  @ViewChild('fileInput') fileInput: ElementRef;

  break = false;

  constructor(
    private fb: FormBuilder,
    private _modificacionMarcaciones: ModificacionMarcionesService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.horasExtrasModificacionMarcaciones;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.calculateCombos();
    this.formulario = this.fb.group({
      department: [''],
      id: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
    });
    this.formularioMarcacion = this.fb.group({
      horaFin: ['', [Validators.required]],
      horaInicio: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      id: [''],
      break: [this.break],
    });
    this.girdComponent();
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  checkValue() {
    this.reviewBreakForForm();
  }

  reviewBreakForForm(rowData?) {
    if (this.break) {
      this.formularioMarcacion.addControl('horaFinBreak', new FormControl('', [Validators.required]));
      this.formularioMarcacion.addControl('horaInicioBreak', new FormControl('', [Validators.required]));
      this.formularioMarcacion.addControl('startDateBreak', new FormControl('', [Validators.required]));
      this.formularioMarcacion.addControl('endDateBreak', new FormControl('', [Validators.required]));

      this.formularioMarcacion.get('startDateBreak').setValue(this.formularioMarcacion.get('startDate').value);
      this.formularioMarcacion.get('endDateBreak').setValue(this.formularioMarcacion.get('startDate').value);
      if (rowData && rowData.ingresoDelBreak) {
        this.formularioMarcacion.get('startDateBreak').setValue(this.getDayToInputFormat(rowData.ingresoDelBreak));
        this.formularioMarcacion.get('endDateBreak').setValue(this.getDayToInputFormat(rowData.salidaAlBreak));
        this.formularioMarcacion.get('horaInicioBreak').setValue(this.getHourToInputFormat(rowData.ingresoDelBreak));
        this.formularioMarcacion.get('horaFinBreak').setValue(this.getHourToInputFormat(rowData.salidaAlBreak));
      }

    } else {
      this.formularioMarcacion.removeControl('horaFinBreak');
      this.formularioMarcacion.removeControl('horaInicioBreak');
      this.formularioMarcacion.removeControl('startDateBreak');
      this.formularioMarcacion.removeControl('endDateBreak');
    }
  }

  getMondayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? -6 : 1);
    const monday = new Date(day.setDate(first));
    return monday;
  }

  getSundayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? 0 : 7);
    const sunday = new Date(day.setDate(first));
    return sunday;
  }

  addDays(date, days) {
    const copy = new Date(Number(date))
    copy.setDate(date.getDate() + days)
    return copy
  }

  formatoFecha(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`;
  }


  changeYear() {
    if (this.formulario.get('year').value) {
      //this.calculateWeeks(this.formulario.get('year').value);
    }
  }

  validateDate(firtDateF, secondDateF) {
    let firtDate = this.getMondayOfCurrentWeek(firtDateF);
    let secondDate = this.getMondayOfCurrentWeek(secondDateF);
    if ((firtDate.getDate() === secondDate.getDate()) && (firtDate.getFullYear() === secondDate.getFullYear()) && (firtDate.getMonth() === secondDate.getMonth())) {
      return true;
    } else {
      return false;
    }
  }

  calculateCombos() {
    this.loading = true;
    const _getAllEmployees = this._modificacionMarcaciones.getAllEmployees();
    const _getAllDepartment = this._modificacionMarcaciones.getAllDepartment();
    forkJoin([_getAllEmployees, _getAllDepartment]).subscribe((res: any) => {
      res[0].map(employe => {
        employe.id = employe.cedula;
        employe.descripcion = employe.nombres + ' | ' + employe.cedula;
      });
      res[1].map(department => {
        department.id = department.descripcion;
      });
      this.cmbEmployees = res[0];
      this.cmbDepartment = res[1];
      this.loading = false;
    }, () => {
      this.loading = false;
      this.cmbEmployees = [];
      this.cmbDepartment = [];
    });
  }

  selectCurrentDate() {
    const date = new Date();
    let year = date.getFullYear();
    this.formulario.get('year').setValue(year);
    this.formulario.get('week').setValue(this.actualWeek);
    this.listAll();
  }

  getAllTMarcaciones() {
    this.loading = true;
    const payload = this.formulario.value;
    this._modificacionMarcaciones.getAll(payload).subscribe((res: any) => {
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'CEDULA',
        field: 'cedula',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'INGRESO',
        field: 'ingreso',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'EGR-BREAK',
        field: 'salidaAlBreak',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'ING-BREAK',
        field: 'ingresoDelBreak',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'EGRESO',
        field: 'salida',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'HORAS TRABAJADAS',
        field: 'horasTrabajas',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'TIPO',
        field: 'tipo',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'FECHA DE ACTUALIZACIÓN',
        field: 'fechaUpdate',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'USUARIO QUE ACTUALIZO',
        field: 'userUpdate',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarMarcacion.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      }
    ];
    this.rowSelection = 'single';
  }

  editarMarcacion({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardEditar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    this.formularioMarcacion.reset();
    this.getFormInfo(rowData);
  }

  getDayToInputFormat(newDate) {
    const date = new Date(newDate);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let dayFormat = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
    return dayFormat;
  }

  getHourToInputFormat(newDate) {
    const date = new Date(newDate);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let dayFormat = `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`;
    return dayFormat;
  }

  getFormInfo(rowData) {
    this.getDayToInputFormat(rowData.ingreso);
    this.formularioMarcacion.get('startDate').setValue(this.getDayToInputFormat(rowData.ingreso));
    this.formularioMarcacion.get('endDate').setValue(this.getDayToInputFormat(rowData.salida));
    this.formularioMarcacion.get('horaInicio').setValue(this.getHourToInputFormat(rowData.ingreso));
    this.formularioMarcacion.get('horaFin').setValue(this.getHourToInputFormat(rowData.salida));
    this.formularioMarcacion.get('id').setValue(rowData.id);
    this.formularioMarcacion.get('break').setValue(rowData.ingresoDelBreak ? true : false);
    this.break = rowData.ingresoDelBreak ? true : false;
    this.reviewBreakForForm(rowData);
  }

  regresar() {
    this.formularioMarcacion.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

  listAll() {
    if (this.formulario.valid) {
      this.getAllTMarcaciones();
    }
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarMarcacion();
      } else {
        this.guardarMarcacion();
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = true;
    }
  }

  guardarMarcacion() {


    const fechaInicioOnlyDate = this.formularioMarcacion.get('startDate').value.split('-');

    const fechaInicioTime = this.formularioMarcacion.get('horaInicio').value.split(':');

    const fechaInicio = new Date(Date.UTC(fechaInicioOnlyDate[0], fechaInicioOnlyDate[1] - 1, fechaInicioOnlyDate[2], fechaInicioTime[0], fechaInicioTime[1]));


    const fechaFinOnlyDate = this.formularioMarcacion.get('endDate').value.split('-');
    const fechaFinTime = this.formularioMarcacion.get('horaFin').value.split(':');
    const fechaFin = new Date(Date.UTC(fechaFinOnlyDate[0], fechaFinOnlyDate[1] - 1, fechaFinOnlyDate[2], fechaFinTime[0], fechaFinTime[1]));
    let payload;

    if (this.break) {
      const fechaInicioBreakOnlyDate = this.formularioMarcacion.get('startDateBreak').value.split('-');

      const fechaInicioBreakTime = this.formularioMarcacion.get('horaInicioBreak').value.split(':');

      const fechaInicioBreak = new Date(Date.UTC(fechaInicioBreakOnlyDate[0], fechaInicioBreakOnlyDate[1] - 1, fechaInicioBreakOnlyDate[2], fechaInicioBreakTime[0], fechaInicioBreakTime[1]));


      const fechaFinBreakOnlyDate = this.formularioMarcacion.get('endDateBreak').value.split('-');
      const fechaFinBreakTime = this.formularioMarcacion.get('horaFinBreak').value.split(':');
      const fechaFinBreak = new Date(Date.UTC(fechaFinBreakOnlyDate[0], fechaFinBreakOnlyDate[1] - 1, fechaFinBreakOnlyDate[2], fechaFinBreakTime[0], fechaFinBreakTime[1]));

      payload = {
        "cedula": this.formulario.get('id').value,
        "fechaInicio": fechaInicio.toISOString(),
        "fechaFin": fechaFin.toISOString(),
        "hora": "",
        "id": this.formularioMarcacion.get('id').value,
        "salidaAlBreak": fechaFinBreak.toISOString(),
        "ingresoDelBreak": fechaInicioBreak.toISOString()
      }
    } else {
      payload = {
        "cedula": this.formulario.get('id').value,
        "fechaInicio": fechaInicio.toISOString(),
        "fechaFin": fechaFin.toISOString(),
        "hora": "",
        "id": this.formularioMarcacion.get('id').value,
        "salidaAlBreak": null,
        "ingresoDelBreak": null,
      }
    }

    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._modificacionMarcaciones.guardarMarcacion(payload),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllTMarcaciones();
      this.regresar();
    });
  }

  actualizarMarcacion() {
    const fechaInicioOnlyDate = this.formularioMarcacion.get('startDate').value.split('-');

    const fechaInicioTime = this.formularioMarcacion.get('horaInicio').value.split(':');

    const fechaInicio = new Date(Date.UTC(fechaInicioOnlyDate[0], fechaInicioOnlyDate[1] - 1, fechaInicioOnlyDate[2], fechaInicioTime[0], fechaInicioTime[1]));


    const fechaFinOnlyDate = this.formularioMarcacion.get('endDate').value.split('-');
    const fechaFinTime = this.formularioMarcacion.get('horaFin').value.split(':');
    const fechaFin = new Date(Date.UTC(fechaFinOnlyDate[0], fechaFinOnlyDate[1] - 1, fechaFinOnlyDate[2], fechaFinTime[0], fechaFinTime[1]));
    let payload;

    if (this.break) {
      const fechaInicioBreakOnlyDate = this.formularioMarcacion.get('startDateBreak').value.split('-');

      const fechaInicioBreakTime = this.formularioMarcacion.get('horaInicioBreak').value.split(':');

      const fechaInicioBreak = new Date(Date.UTC(fechaInicioBreakOnlyDate[0], fechaInicioBreakOnlyDate[1] - 1, fechaInicioBreakOnlyDate[2], fechaInicioBreakTime[0], fechaInicioBreakTime[1]));


      const fechaFinBreakOnlyDate = this.formularioMarcacion.get('endDateBreak').value.split('-');
      const fechaFinBreakTime = this.formularioMarcacion.get('horaFinBreak').value.split(':');
      const fechaFinBreak = new Date(Date.UTC(fechaFinBreakOnlyDate[0], fechaFinBreakOnlyDate[1] - 1, fechaFinBreakOnlyDate[2], fechaFinBreakTime[0], fechaFinBreakTime[1]));

      payload = {
        "cedula": this.formulario.get('id').value,
        "fechaInicio": fechaInicio.toISOString(),
        "fechaFin": fechaFin.toISOString(),
        "hora": "",
        "id": this.formularioMarcacion.get('id').value,
        "salidaAlBreak": fechaFinBreak.toISOString(),
        "ingresoDelBreak": fechaInicioBreak.toISOString()
      }
    } else {
      payload = {
        "cedula": this.formulario.get('id').value,
        "fechaInicio": fechaInicio.toISOString(),
        "fechaFin": fechaFin.toISOString(),
        "hora": "",
        "id": this.formularioMarcacion.get('id').value,
        "salidaAlBreak": null,
        "ingresoDelBreak": null,
      }
    }
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this._modificacionMarcaciones.actualizarMarcacion(payload),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllTMarcaciones();
      this.regresar();
    });
  }

  nuevo() {
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.guardar;
    this.editableForm = false;
    this.formularioMarcacion.reset();
  }

  eliminar({rowData}) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this._modificacionMarcaciones.eliminarMarcacion(rowData.id),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
    });
  }

  downloadReport() {
    const payload = this.formulario.value;
    this._modificacionMarcaciones.downloadReport(payload).subscribe((res) => {
      const dataURI = "data:aplication/plain;base64," + (res);
      var a = document.createElement("a");
      a.href = dataURI;
      const name_file = `reporte_marcaciones${Date.now()}.xlsx`;
      a.setAttribute("download", name_file);
      a.click();

    })
  }

  downloadReportReplica() {
    const payload = this.formulario.value;
    this._modificacionMarcaciones.downloadReportReplica(payload).subscribe((res) => {
      const dataURI = "data:aplication/plain;base64," + (res);
      var a = document.createElement("a");
      a.href = dataURI;
      const name_file = `reporte_marcacionesReplica${Date.now()}.xlsx`;
      a.setAttribute("download", name_file);
      a.click();

    })
  }


  /*  onFileSelect(event) {
      this.loading = true;
      let allowedExtensions = /(.xlsx)$/i;
      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        if (!allowedExtensions.exec(file.name)) {
          this.uploadForm.get('excel').setValue('');
          this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "xlsx" (EXCEL) ', true, 9000);
          this.fileInput.nativeElement.value = '';
          this.loading = false;
        } else {
          this.uploadForm.get('excel').setValue(file);
          const formData = new FormData();
          formData.append('file', this.uploadForm.get('excel').value);
          const payload = this.formulario.value;
          this._horasExtrasTurnos.loadShifts(payload, formData).subscribe(response => {
            this.listAll();
          });
        }
      }
    }*/
}
